module.exports = __webpack_public_path__ + "img/tree-07-b-trunk.6153fa15.png";